// extracted by css-extract-rspack-plugin
export default {"wrapper":"wrapper--rTU5kVvRBxgGmsx3"};